import { useParams } from 'react-router-dom';
import useProcessingEntry from '../../hooks/processing/useProcessingEntry';
import ErrorMessage from '../../components/shared/ErrorMessage';
import { Grid, Typography, Divider, Box, Button } from '@mui/material';
import BackButton from '../../components/shared/BackButton';
import CustomerProcessingRuns from '../../components/processing/customer/CustomerProcessingRuns';
import useAccountSettings from '../../hooks/settings/useAccountSettings';
import { useEffect, useState } from 'react';
import CustomerTicketEntry from '../../components/processing/customer/CustomerTicketEntry';
import {useSnackbar} from "notistack";

export default function CustomerTicketDetails() {
  const { enqueueSnackbar } = useSnackbar();
  const { logId } = useParams<{ logId: string }>();
  const { logEntry, loadError, processingRuns, processingEntry } = useProcessingEntry(logId, null);
  const { subdomain, getZendeskSubdomain } = useAccountSettings(enqueueSnackbar);
  const [zendeskUrl, setZendeskUrl] = useState<string>('');

  useEffect(() => {
    if (subdomain) {
      setZendeskUrl(`https://${subdomain}.zendesk.com/agent/tickets/${logEntry?.external_id}`);
    }
  }, [subdomain, logEntry?.external_id]);

  if (loadError) {
    return <ErrorMessage errorMsg={loadError} />;
  }

  if (!processingRuns) {
    return <Typography variant="h5">Loading...</Typography>;
  }

  return (
    <Box sx={{ padding: 3 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <BackButton btnText={'Back'} />

        {zendeskUrl && (
          <Button variant="contained" color="primary" onClick={() => window.open(zendeskUrl, '_blank')}>
            Open in Zendesk
          </Button>
        )}
      </Box>

      <Divider style={{ marginTop: '20px', marginBottom: '20px' }} />

      <Typography variant="h4">Ticket Information</Typography>

      {processingEntry && <CustomerTicketEntry processingEntry={processingEntry} />}

      <Divider sx={{ marginY: '50px' }} />

      <Typography variant="h4" gutterBottom>
        Processing Runs
      </Typography>
      <Grid container sx={{ marginTop: 2 }}>
        {processingRuns.map((run, index) => (
          <Grid item xs={12} key={index}>
            <CustomerProcessingRuns index={index} run={run} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
